import { render, staticRenderFns } from "./column-data.vue?vue&type=template&id=12a030b0&"
import script from "./column-data.vue?vue&type=script&lang=js&"
export * from "./column-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports